import { render, staticRenderFns } from "./CatalogTemplate.vue?vue&type=template&id=d9d8ee12"
import script from "./CatalogTemplate.vue?vue&type=script&lang=ts"
export * from "./CatalogTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports